module.exports = __webpack_public_path__ + "img/mow.f0f21c99.png";